import React, { useEffect, useState, useRef } from "react";
import {
  DialogActions,
  IconButton,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { OverlayPanel } from "primereact/overlaypanel";
import { Card } from "react-bootstrap";
import { Search } from "@mui/icons-material";
import Illustration from "../../../../partials/content/Illustration";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import NumberFormat from "react-number-format";
import DialogLayout from "../../../../partials/content/DialogLayout";
import SearchFiscalYear from "../../setup/finance/searchFiscalYear";
import { getSalesTargetReport } from "../../../../services/sales/salesReportService";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";

function SalesTargetReport(props) {
  const { currentFiscalYear, reload } = useGlobalData();
  const selectParamOp = useRef(null);
  const [openSearchFiscalYear, setOpenSearchFiscalYear] = useState(false);
  const [salesTarget, setSalesTarget] = useState([]);
  const [fiscalYear, setFiscalYear] = useState(
    currentFiscalYear.ID > 0
      ? currentFiscalYear
      : {
          ID: 0,
          year: 0,
          yearTo: 0,
          startMonth: 0,
          startMonthName: "",
          endMonth: 0,
          endMonthName: "",
        }
  );

  useEffect(() => {
    getSalesTargetData();
  }, [reload]);

  const salesTargetUsersColumn = [
    {
      header: "Sales Name",
      field: "fullName",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Currency",
      field: "currencyCode",
      body: null,
      sortable: true,
      filter: true,
      hidden: true,
    },
    {
      header: "Sales Target",
      field: "salesTarget",
      body: (rowData) => (
        <NumberFormat
          value={rowData.salesTarget}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Sales Achieved",
      field: "salesAchieved",
      body: (rowData) => (
        <NumberFormat
          value={rowData.salesAchieved}
          displayType={"text"}
          thousandSeparator={true}
          decimalScale={2}
          renderText={(value) => (
            <div className="float-right">
              {rowData.currencyCode} {value}
            </div>
          )}
        />
      ),
      sortable: true,
      filter: true,
    },
    {
      header: "Activity Target",
      field: "activityTarget",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "Activity Achieved",
      field: "activityAchieved",
      body: null,
      sortable: true,
      filter: true,
    },
    {
      header: "KPI",
      field: "KPI",
      body: null,
      sortable: true,
      filter: true,
    },
  ];

  return (
    <React.Fragment>
      <OverlayPanel
        ref={selectParamOp}
        showCloseIcon
        dismissable={false}
        id="overlay_panel"
        style={{ width: "450px" }}
        className="overlaypanel-demo"
      >
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <Card>
              <Card.Header>
                <i className="fas fa-filter"></i>
                <span>
                  <strong>Filter Selection</strong>
                </span>
              </Card.Header>
              <Card.Body>
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-12">
                    <TextField
                      id="fiscalYear"
                      label="Fiscal Year"
                      value={
                        fiscalYear.startMonthName +
                        " " +
                        fiscalYear.year +
                        " - " +
                        fiscalYear.endMonthName +
                        " " +
                        fiscalYear.yearTo
                      }
                      variant="outlined"
                      size="small"
                      style={{ width: "100%" }}
                      margin="normal"
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <BootstrapTooltip title="Search">
                              <IconButton
                                type="button"
                                aria-label="Search"
                                onClick={() => {
                                  setOpenSearchFiscalYear(true);
                                }}
                                edge="end"
                              >
                                <Search />
                              </IconButton>
                            </BootstrapTooltip>
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                    />
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-12">
            <button
              type="button"
              className="btn btn-success btn-md btn-pill btn-bold float-right"
              onClick={() => {
                getSalesTargetData();
              }}
            >
              <i className="fas fa-search"></i>
              Get Sales Target
            </button>
          </div>
        </div>
      </OverlayPanel>
      {salesTarget.length ? (
        <React.Fragment>
          <CustomDataTable
            data={salesTarget}
            dataDetailName="salesTargetUsers"
            dataDetailColumns={salesTargetUsersColumn}
            dataDetailTitle="Salesman Target Breakdown"
            onRefreshData={() => {
              getSalesTargetData();
            }}
            buttons={[
              {
                name: "Filter",
                onClick: (e) => {
                  selectParamOp.current.toggle(e);
                },
                icon: "fas fa-search",
                color: "info",
              },
            ]}
            columns={[
              {
                header: "Start Target",
                field: "startTarget",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "End Target",
                field: "endTarget",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Group",
                field: "salesGroup",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Sales Target",
                field: "salesTarget",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesTarget}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Sales Achieved",
                field: "salesAchieved",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.salesAchieved}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Activity Target",
                field: "activityTarget",
                body: null,
                sortable: true,
                filter: true,
              },
              {
                header: "Activity Achieved",
                field: "activityAchieved",
                body: null,
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Sales.png"
            description={`You don't have any Sales Target for current data selection!`}
            guidance={`Hint: Try to filter another data selection to get some results`}
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
          <div className="text-center py-3">
            <button
              type="button"
              className="btn btn-info btn-md btn-pill btn-bold mx-1"
              onClick={(e) => {
                selectParamOp.current.toggle(e);
              }}
            >
              <i className="fas fa-search"></i>
              Filter
            </button>
          </div>
        </React.Fragment>
      )}
      <DialogLayout
        open={openSearchFiscalYear}
        title="Search Fiscal Year"
        onCloseDialog={() => {
          setOpenSearchFiscalYear(false);
        }}
        maxWIdth="md"
      >
        <SearchFiscalYear
          onSelectFiscalYear={(fiscalYear) => {
            setFiscalYear(fiscalYear);
            setOpenSearchFiscalYear(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchFiscalYear(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );

  async function getSalesTargetData() {
    if (fiscalYear.ID > 0) {
      const response = await getSalesTargetReport(fiscalYear.ID);
      const { data } = response.data;
      setSalesTarget(data.salesTargetReport);
    }
  }
}

export default SalesTargetReport;
